import http from "../../http-common";

const handle = (promise) =>
  promise
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });

const getUsers = async () => handle(http.get("/ultimate/users"));

const getUsersHighlight = async (query) =>
  handle(http.get("/ultimate/users/highlight", { params: query }));

const getUser = async (id) => handle(http.get(`/ultimate/users/${id}`));

const getUserPayments = async (id) =>
  handle(http.get(`/ultimate/users/${id}/payments`));

const getUserSecurity = async (id) =>
  handle(http.get(`/ultimate/users/${id}/security`));

const searchUsers = async (params) =>
  handle(http.get("/ultimate/users/search", { params }));

const updateUser = async (id, data) =>
  handle(http.put(`/ultimate/users/${id}`, data));

const setUserActive = async (id, active) =>
  handle(http.post(`/ultimate/users/${id}/${active ? "unblock" : "block"}`));

export default {
  getUsers,
  getUsersHighlight,
  getUser,
  getUserPayments,
  getUserSecurity,
  searchUsers,
  updateUser,
  setUserActive,
};
